import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { ActiveStay } from 'src/features/stay/types';

const RESOURCE = `sp-core/:parkingId/visitors/active-stay/:stayId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    stayId: string;
    parkingId: string;
}
const queryFn = ({ stayId, parkingId, ...params }: DTO): Promise<ActiveStay> => {
    return axios.get(formatResourcePath(RESOURCE, { stayId, parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as ACTIVE_STAY_RESOURCE, useQueryHook as useGetActiveStay };
